import { style } from '@angular/animations';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
  selector: 'll-button-comp',
  template: `
  <button nbButton style="cursor:pointer;border-color: #d93; margin-right: 5px; background-color: #d93;color:white;" status="basic" size="tiny" (click)="onClick('DASHBOARD')">Indicadores</button>
  `,
})

export class MyCustomComponent implements OnInit {
  @Input() rowData: any;
  @Input() labelButton: any;

  @Output() save: EventEmitter<any> = new EventEmitter();


  ngOnInit() {

  }

  onClick(context) {
    this.rowData.context = context;
    this.save.emit(this.rowData);
  }
}
